import { defineSetting } from '../settingsRegistry';

declare module '../settingsRegistry' {
  interface Settings {
    /**
     * The always-on inner-power aura (render/passes/innerAura.ts): 0 everyone's, 1 the player's own only, 2 off.
     * How many are drawn at once follows the graphics tier.
     */
    innerAura: number;
  }
}

defineSetting({
  key: 'innerAura',
  // Off until the review GIFs pass (docs/anim/aura-neigong); then 0 (everyone), as decided 2026-10-13.
  default: 2,
  order: 106,
  menu: {
    group: 'visual',
    label: 'ออร่ากำลังภายใน',
    choices: ['ทุกคน', 'เฉพาะตัวเอง', 'ปิด'],
    note: () => 'ไอกำลังภายในรอบตัว สีตามกำลังภายในที่ฝึก ยิ่งขั้นสูงยิ่งเข้ม',
  },
});
